import styled from 'styled-components';

const StyledArticlesHead = styled.div`
  padding-top: ${props => props.theme.components_spacing_desk.xxlarge}px;
  padding-bottom: ${props => props.theme.components_spacing_desk.xlarge}px;
  padding-right: 64px;
  padding-left: 64px;
  .main-title{
    width: 58.3%;
    text-align: left;
    margin-right: 0;
    margin-left: auto;
    margin-bottom: ${props => props.theme.components_spacing_desk.xlarge}px;
  }
  .articles-top--wrap{
    position: relative;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
  }
  .article--big{
    position: sticky;
    top: 150px;
    flex: 0 0 58.3%;
    max-width: 58.3%;
  }
  .article--big .cover-wrap {
    position: relative;
    display: block;
    width: 100%;
    margin-top: 40px;
    overflow: hidden
  }
  .article--big .cover {
    position: relative;
    display: block;
    width: 100%;
  }
  .articles--col{
    flex: 0 0 33.3%;
    max-width: 33.3%
  }
  .articles--col .news-follow-cursor{
    position: fixed;
    pointer-events: none;
    opacity: 0;
    visibility: hidden;
    z-index: 1;
    width: 256px;
    height: 256px;
    border-radius: 50%;
    overflow: hidden;
    background-size: cover;
    top: var(--y, 0);
    left: var(--x, 0);
    transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    filter: url(#green-filter);
  }
  .article--cell{
    position: relative;
    z-index: 2;
  }
  .title-article {
    position: relative;
    z-index: 2;
    cursor: pointer;
  }
  .category{
    position: relative;
    text-transform: uppercase;
    padding: 14px 0;
    z-index: 2;
    margin-bottom: 24px;
    cursor: pointer;
    color: ${ props => props.theme.colors.green_secondary};
  }
  .articles--col .category {
    margin-bottom: 16px;
  }
  .details-wrapper {
    position: relative;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    color: #4D4D4D;
    margin-top: 24px;
    z-index: 2;
    flex-wrap: wrap;
  }
  .detail-col{
    display: flex;
    align-items: center;
    margin-right: 24px;
  }
  .detail-col p{
    white-space: nowrap;
  }
  .detail-col img {
    margin-right: 8px;
  }
  .article--cell{
    margin-bottom: ${props => props.theme.components_spacing_desk.medium}px;
  }
  @media screen and (max-width: 1439px){
    padding-right: 40px;
    padding-left: 40px;
    .articles--col .details-wrapper {
      flex-direction: column;
      text-align: left;
      justify-content: flex-start;
      align-items: flex-start;
    }
    .articles--col .detail-col:nth-child(1){
      margin-bottom: 24px
    }
  }
  @media screen and (max-width: 1023px){
    .main-title{
      margin-bottom: ${props => props.theme.components_spacing_tablet.xlarge}px;
    }
    .articles-top--wrap{
      display: block;
    }
    .article--big,
    .articles--col{
      position: relative;
      top: auto;
      flex: 0 0 100%;
      max-width: 100%;
    }
    .articles--col{
      margin-top: 80px;
    }
    .articles--col .details-wrapper {
      flex-direction: row;
    }
    .article--cell{
      margin-bottom: ${props => props.theme.components_spacing_tablet.medium}px;
    }
    .articles--col .detail-col:nth-child(1){
      margin-bottom: 0
    }
    padding-top: ${props => props.theme.components_spacing_tablet.xxlarge}px;
    padding-bottom: ${props => props.theme.components_spacing_tablet.xxlarge}px;
  }
  @media screen and (max-width: 767px){
    .main-title{
      width: 100%;
      margin-bottom: ${props => props.theme.components_spacing_mobile.xlarge}px;
    }
    .articles--col{
      margin-top: 64px;
    }
    .article--cell{
      margin-bottom: ${props => props.theme.components_spacing_mobile.medium}px;
    }
    padding-right: 24px;
    padding-left: 24px;
    padding-top: ${props => props.theme.components_spacing_mobile.xxlarge}px;
    padding-bottom: ${props => props.theme.components_spacing_mobile.xxlarge}px;
  }
`;

export {
  StyledArticlesHead
};

